module.exports = __webpack_public_path__ + "media/images/home-icon-d341ec7a5de3f1649ff09c010b578dff.svg";